import { render, staticRenderFns } from "./BindIpByVdDialog.vue?vue&type=template&id=168c0ae2&scoped=true"
import script from "./BindIpByVdDialog.vue?vue&type=script&lang=ts"
export * from "./BindIpByVdDialog.vue?vue&type=script&lang=ts"
import style0 from "./BindIpByVdDialog.vue?vue&type=style&index=0&id=168c0ae2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168c0ae2",
  null
  
)

export default component.exports